<template>
  <div>
    <header-component pageType="write"  :menuIndex="1"/>
    <div class="content1 flex flex-column flex-align-center">
      <div class="common-txt1" data-aos="fade-up">{{ $t('solution2.content1.title1') }}</div>
      <div class="txt2" data-aos="fade-up" data-aos-delay="100">{{ $t('solution2.content1.title2') }}</div>
      <div class="common-txt3" data-aos="fade-up" data-aos-delay="200">{{ $t('solution2.content1.desc') }}</div>
      <div class="ty" @click="$refs.connectRef.toConnectIndex()" data-aos="fade-up" data-aos-offset="300" data-aos-delay="300">{{ $t('solution2.content1.btn') }}</div>
      <img src="@/assets/image/solution2/Slice 37@2x.png" data-aos="fade-up" data-aos-offset="300" data-aos-delay="400"/>
    </div>
    <div class="content2 flex flex-column flex-align-center">
      <div class="common-txt1" data-aos="fade-up">{{ $t('solution2.content2.title') }}</div>
      <div class="common-txt3" data-aos="fade-up" data-aos-delay="100" v-html="$t('solution2.content2.desc')"></div>
      <div class="flex flex-justify-center card-nav">
        <div class="flex card flex-column flex-justify-center flex-align-center" @mouseenter="hover1 = true" @mouseleave="hover1 = false">
          <div class="txt1" :class="{ active: hover1 }">{{ $t('solution2.content2.card1') }}</div>
          <div class="txt2" :class="{ active: hover1 }"  data-aos="fade-up" @click="$refs.connectRef.toConnectIndex()">{{ $t('solution2.content2.btn') }}</div>
        </div>
        <div class="flex card flex-column flex-justify-center flex-align-center" @mouseenter="hover2 = true" @mouseleave="hover2 = false">
          <div class="txt1" :class="{ active: hover2 }">{{ $t('solution2.content2.card2') }}</div>
          <div class="txt2" :class="{ active: hover2 }"  data-aos="fade-up" @click="$refs.connectRef.toConnectIndex()">{{ $t('solution2.content2.btn') }}</div>
        </div>
      </div>
    </div>
    <div class="content3 flex flex-column flex-align-center">
      <div class="common-txt1" data-aos="fade-up" >{{ $t('solution2.content3.title') }}</div>
      <div class="common-txt3" data-aos="fade-up" data-aos-delay="100" v-html="$t('solution2.content3.desc')"></div>
      <div class="img-nav">
        <img src="@/assets/image/solution2/Slice 46@2x.png" class="img1" data-aos="fade-up" data-aos-delay="100"/>
        <img src="@/assets/image/solution2/Slice 46@2x (1).png" class="img2" data-aos="fade-up" data-aos-delay="200"/>
        <img src="@/assets/image/solution2/Slice 46@2x (2).png" class="img3" data-aos="fade-up" data-aos-delay="300"/>
        <img src="@/assets/image/solution2/Slice 46@2x (3).png" class="img4" data-aos="fade-up" data-aos-delay="400"/>
      </div>
    </div>
    <div class="content4 flex flex-column flex-align-center">
      <div class="common-txt1">{{ $t('solution2.content4.title') }}</div>
      <div class="common-txt3" data-aos="fade-up" data-aos-delay="100" v-html="$t('solution2.content4.desc')"></div>
      <div class="item-nav flex flex-justify-between" data-aos="slide-right" data-aos-delay="100">
        <div class="item">
          <div class="txt1">{{ $t('solution2.content4.item1.title') }}</div>
          <div class="txt2">{{ $t('solution2.content4.item1.desc') }}</div>
        </div>
        <div class="empty"></div>
      </div>
      <div class="item-nav flex flex-justify-between" data-aos="slide-left" data-aos-delay="100">
        <div class="empty"></div>
        <div class="item">
          <div class="txt1">{{ $t('solution2.content4.item2.title') }}</div>
          <div class="txt2">{{ $t('solution2.content4.item2.desc') }}</div>
        </div>
      </div>
      <div class="item-nav flex flex-justify-between" data-aos="slide-right" data-aos-offset="100" data-aos-delay="100">
        <div class="item">
          <div class="txt1">{{ $t('solution2.content4.item3.title') }}</div>
          <div class="txt2">{{ $t('solution2.content4.item3.desc') }}</div>
        </div>
        <div class="empty"></div>
      </div>
    </div>
    <connect-component ref="connectRef" @kf="$refs.connectRef.toConnectIndex()"></connect-component>
    <kf-component kf-top="1086px" ref="kfContainer"></kf-component>
  </div>
</template>
<script>
export default {
  name: 'solution1-page',
  data () {
    return {
      hover1: false,
      hover2: false
    }
  }
}
</script>
<style lang="less" scoped>
.common-txt1 {
  color: #000000;
  font-size: 60px;
  line-height: 90px;
  font-weight: bold;
}

.common-txt3 {
  font-family: Inter, Inter;
  font-weight: 400;
  font-size: 20px;
  color: #979797;
  line-height: 30px;
  width: 651px;
  text-align: center;
  margin-top: 20px;
}

.content1 {
  margin: 200px auto 130px;

  .txt2 {
    color: #4947D7;
    font-size: 60px;
    line-height: 90px;
    font-weight: bold;
  }

  .ty {
    position: relative;
    width: 257px;
    height: 44px;
    line-height: 44px;
    font-family: Inter, Inter;
    font-weight: bold;
    font-size: 17px;
    color: #000000;
    letter-spacing: 12px;
    text-align: center;
    background: #fff;
    /* 设置内部背景色 */
    border-radius: 62px;
    /* 圆角 */
    overflow: hidden;
    /* 确保伪元素不会溢出 */
    z-index: 1;
    /* 确保内容在伪元素之上 */
    margin-top: 20px;
    cursor: pointer;
  }

  .ty::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 62px;
    /* 圆角与主元素保持一致 */
    padding: 2px;
    /* 边框宽度 */
    background: linear-gradient(90deg, rgba(255, 132, 194, 1), rgba(160, 43, 254, 1));
    /* 渐变边框 */
    -webkit-mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    /* 遮罩 */
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
    /* 遮罩组合 */
    z-index: -1;
    /* 伪元素位于内容之下 */
  }

  img {
    width: 1090px;
    height: 533px;
    margin-top: -9px;
  }
}

.content2 {
  .common-txt3 {
    margin-top: 29px;
  }

  .card-nav {
    margin: 124px auto 78px;

    .card {
      width: 599px;
      height: 400px;
      padding: 20px;
      box-sizing: border-box;
      background: url('@/assets/image/solution2/Slice 43@2x.png') no-repeat center/100% 100%;

      .txt2 {
        width: 283px;
        height: 80px;
        border-radius: 80px 80px 80px 80px;
        border: 1px solid #FFFFFF;
        font-family: Poppins, Poppins;
        font-weight: 500;
        font-size: 22px;
        color: #FFFFFF;
        line-height: 80px;
        letter-spacing: 2px;
        text-align: center;
        margin-top: 17px;
        cursor: pointer;
        
        opacity: 0;
        transform: translateY(20px);
        transition: opacity 0.3s ease-in-out, transform 0.3s ease-in-out;
      }

      &:nth-of-type(2) {
        margin-left: 100px;
        background: url('@/assets/image/solution2/Slice 43@2x(1).png') no-repeat center/100% 100%;

        .txt2 {
          border: none;
          background: #6C54E7;
        }
      }

      .txt1 {
        font-family: Poppins, Poppins;
        font-weight: bold;
        font-size: 32px;
        color: #FFFFFF;
        transition: transform 0.3s ease-in-out;
        transform: translateY(50px);
      }
      &:hover{
        .txt1{
          transform: translateY(-20px);
        }
        .txt2 {
          opacity: 1;
          transform: translateY(0);
        }
      }

    }
  }

}

.content3 {
  .common-txt3 {
    margin-top: 29px;
  }

  .img-nav {
    width: 1106px;
    height: 556px;
    position: relative;
    .img1{
      position: absolute;
      width: 197px;
      height: 120px;
      left: 0;
      top: 50px;
      z-index: 1;
    }
    .img2{
      position: absolute;
      width: 260px;
      height: 92px;
      left: 0;
      top: 196px;
      z-index: 1;
    }
    .img3{
      position: absolute;
      width: 428px;
      height: 238px;
      left: 0;
      bottom: 0;
      z-index: 1;

    }
    .img4{
      position: absolute;
      width: 658px;
      height: 534px;
      right: 0;
      bottom: 0;
    }
  }
}

.content4 {
  margin: 100px auto 0;
  padding-top: 120px;
  min-height: 977px;
  background: url('@/assets/image/solution2/Slice 45@2x.png') no-repeat center/100% 100%;

  .common-txt1 {
    color: #FFFFFF;
  }

  .common-txt3 {
    margin: 29px 0 108px;
  }

  .item-nav {
    padding: 0 175px;
    margin-bottom: 37px;
    &>div{
      &:nth-child(1){
        margin-right: 45px;
      }
    }
    .item {
      width: 240px;
      min-height: 200px;
      box-sizing: border-box;
      background: rgba(30, 30, 30, 0.6);
      border-radius: 0px 0px 0px 0px;
      padding: 30px 30px 50px;
      .txt1{
        font-family: Poppins, Poppins;
        font-weight: bold;
        font-size: 19px;
        color: #AC70FF;
        margin-bottom: 19px;
      }
      .txt2{
        font-family: Poppins, Poppins;
        font-weight: 400;
        font-size: 16px;
        color: #FFFFFF;
        line-height: 24px;
      }
      &:nth-of-type(2n){
        border-left: 4px solid #AC70FF;
        
      }
      &:nth-of-type(2n - 1){
        border-right: 4px solid #AC70FF;
        .txt1{
          text-align: right;
        }
        .txt2{
          text-align: right;
        }
      }
    }
    .empty{
      width: 300px;
    }
  }
}
</style>